import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?w=800&q=80',
    alt: 'Velas artesanales',
    span: 'md:col-span-2 md:row-span-2'
  }, {
    url: 'https://images.unsplash.com/photo-1600857544200-b2f666a9a2ec?w=600&q=80',
    alt: 'Jabones naturales',
    span: 'md:col-span-1 md:row-span-1'
  }, {
    url: 'https://images.unsplash.com/photo-1607006344380-b6775a0824a7?w=600&q=80',
    alt: 'Jabones artesanales naturales',
    span: 'md:col-span-1 md:row-span-1'
  }];
  return <section className="py-20 bg-artisanal-beige" data-id="element-172">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-174">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-175">
            Crea piezas dignas de admirar
          </h2>
          <p className="font-sans text-lg text-artisanal-brown/80 max-w-2xl mx-auto" data-id="element-176">
            Logra acabados premium, texturas delicadas y aromas envolventes.
            Productos tan hermosos que no querrás usarlos... o que tus clientes
            amarán comprar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[250px]" data-id="element-177">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative rounded-2xl overflow-hidden group ${img.span}`} data-id="element-178">
              <img src={img.url} alt={img.alt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-179" />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-180"></div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}